import Link from "../../Link";

const Django = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/64" title={"OpenBootcamp Django(Python)"} />
        </div>
    );
}

export default Django;